import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Layout } from '../Layout/Layout';
import './HospitalTabLayout.css';

const TABS = [
  { label: 'Hospital Similarity', path: '/hospital_similarity' },
  { label: 'Hospital Maintenance', path: '/hospital_maintenance' },
];

const HospitalTabLayout: React.FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <Layout>
      {/* Sticky tab bar — always visible across all three pages */}
      <div className="htl-bar">
        <div className="htl-bar-inner">
          {TABS.map((tab) => (
            <button
              key={tab.path}
              className={`htl-tab${pathname === tab.path ? ' htl-tab--active' : ''}`}
              onClick={() => navigate(tab.path, { state: { reset: Date.now() } })}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Each child route renders here */}
      <div className="htl-content">
        <Outlet />
      </div>
    </Layout>
  );
};

export default HospitalTabLayout;
